const idPortalApi = "50538d34467e622b9da079d66944384bf13f8921";

module.exports = {
  tokenLink: idPortalApi,
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  link: "http://www.transparenciadministrativa.com.br",
  urlADM: `https://administracaopublica.com.br`,
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem",
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/",

  // urlApi: `http://localhost:8004/${idPortalApi}`,
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  urlEmDeploy: "https://cmolhodaguadascunhas.ma.gov.br/", //usada para link de compartilhamento
  dnsPortal: "cmolhodaguadascunhas.ma.gov.br",
  NomePortal: "Olho d'Água das Cunhãs",
  ufPortal: "MA",
  NomeTipoPortal: "Câmara Municipal", //Prefeitura ou Câmara
  TipoPortal: 4, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true,
  countNewsHome: 6, //quantidade de noticias na home
  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario
  corIcones: "#b28e08",

  //links externos
  link_youtube: `https://www.youtube.com/@camaramunicipaldeodc`,
  link_twitter: `https://x.com/camaraodcma`,
  link_localize: `https://maps.app.goo.gl/YsvoJrXjRJM8qopF7`,
  //Mapa da pagina Municipio/Mapa
  link_mapa: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20925.682291581645!2d-45.118242719652656!3d-4.142708735476724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92cb2f260761bdd1%3A0xfb542de653adeafe!2sOlho%20d&#39;%C3%81gua%20das%20Cunh%C3%A3s%2C%20State%20of%20Maranh%C3%A3o!5e0!3m2!1sen!2sbr!4v1739461197128!5m2!1sen!2sbr`,
};
